import { call, put, takeEvery } from "redux-saga/effects";
import {getTable} from '../../../services/mainServices'
import {catalogsMenu} from '../../../helpers/adipiBackendUrl'

// Crypto Redux States
import { 
  GET_CATALOGS_MENU, 
 } from "./actionTypes";
import {
  getCatalogsSuccess,
  getCatalogsFail,
  setState,
} from "./actions";

function* fetchCatalogs( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable, catalogsMenu, params);
    // console.log('Response succesful:', response)
    yield put(setState(false))
    yield put(getCatalogsSuccess(response.catalogs.items,response.catalogs.totalPages, response.catalogs.currentPage));
  } catch (error) {
    yield put(getCatalogsFail(error));
  }
}

function* menuCatalogSaga() {
  yield takeEvery(GET_CATALOGS_MENU, fetchCatalogs);
}

export default menuCatalogSaga;
